import React from 'react';

import DietSettingsConnectorApollo from '@dietlabs/components/src/ApolloConnectors/DietSettings/Fetch/DietSettingsConnectorApollo';
import GoalChangeConnectorApollo from '@dietlabs/components/src/ApolloConnectors/MakeDecision/GoalChange/GoalChangeConnectorApollo';
import DietModeChangeConnectorApollo from '@dietlabs/components/src/ApolloConnectors/MakeDecision/DietModeChange/DietModeChangeConnectorApollo';
import MakeDecisionContainer from './MakeDecisionContainer';

class MakeDecisionPage extends React.Component {
    static propTypes = {};

    render() {
        return (
            <DietSettingsConnectorApollo>
                {({ ...dietSettingsData }) => (
                    <DietModeChangeConnectorApollo>
                        {({ ...dietModeChange }) => (
                            <GoalChangeConnectorApollo>
                                {({ ...goalChange }) => (
                                    <MakeDecisionContainer
                                        {...dietSettingsData}
                                        {...dietModeChange}
                                        {...goalChange}
                                    />
                                )}
                            </GoalChangeConnectorApollo>
                        )}
                    </DietModeChangeConnectorApollo>
                )}
            </DietSettingsConnectorApollo>
        );
    }
}

export default MakeDecisionPage;
